import { z } from 'zod'

export const problemIssueSchema = z.object({
  code: z.string(),
  path: z.array(z.union([z.string(), z.number()])),
})

export const problemDetailsSchema = z.object({
  type: z.string(),
  status: z.number().int().min(100).max(599),
  code: z.string(),
  issues: z.array(problemIssueSchema).optional(),
  /** The existing record behind a conflict, when the caller can act on it. */
  resourceId: z.string().optional(),
})

export type ProblemIssue = z.infer<typeof problemIssueSchema>

export type ConflictCode =
  | 'draft-conflict'
  | 'workspace-slug-unavailable'
  | 'workspace-last-owner'
  | 'workspace-member-exists'
  | 'invitation-pending'
  | 'invitation-not-pending'
  | 'invitation-already-used'
  | 'venue-already-added'
  | 'wedding-supplier-exists'
  | 'catalog-supplier-duplicate'
  | 'budget-category-not-empty'
  | 'budget-system-category-delete'
  | 'budget-linked-expense-delete'
  | 'budget-supplier-already-linked'
  | 'document-not-ready'
  | 'catalog-supplier-image-attached'

export type ForbiddenCode =
  | 'forbidden'
  | 'workspace-write-required'
  | 'workspace-owner-required'
  | 'invitation-email-mismatch'
  | 'impersonation-read-only'
  | 'admin-required'

export type ValidationCode =
  | 'invalid-input'
  | 'invalid-assignee'
  | 'automatic-task-status-managed'
  | 'budget-payment-exceeds-expense'
  | 'budget-expense-below-payments'
  | 'contact-method-required'
  | 'upload-mismatch'
  | 'remote-image-rejected'
  | 'catalog-supplier-image-limit'

export type ServiceUnavailableCode =
  | 'dependency-unavailable'
  | 'storage-unavailable'
  | 'workspace-create-failed'
  | 'workspace-update-failed'
  | 'wedding-create-failed'
